export const DEFAULT_IMAGE = '/images/nft_logo.png';
